import React from 'react';
import {
  BusinessOutlined as BusinessIcon,
  PersonOutlined as PersonIcon,
  AssignmentOutlined as AssignmentIcon,
  FactoryOutlined as FactoryIcon,
  CreateOutlined as CreateIcon,
  FolderOutlined as FolderIcon,
} from '@mui/icons-material';

import { NavigationPanelCommon } from '@/components/navigation-panel-common';
import { NavigationSection } from '@/components/types/types';

interface NavigationPanelProps {
  isDetailPage: boolean;
}

export const NavigationPanel: React.FC<NavigationPanelProps> = ({ isDetailPage }) => {
  const sections: NavigationSection[] = [
    {
      id: 'basic-information',
      label: '現場基本情報',
      anchor: 'basic-information-section',
      icon: <BusinessIcon />,
    },
    { id: 'onsite-staff', label: '現場担当', anchor: 'onsite-staff-section', icon: <PersonIcon /> },
    {
      id: 'representatives',
      label: '野原担当',
      anchor: 'representatives-section',
      icon: <AssignmentIcon />,
    },
    {
      id: 'contract-factory',
      label: '契約工場',
      anchor: 'contract-factory-section',
      icon: <FactoryIcon />,
    },
    // Detail Page Only Sections
    ...(isDetailPage
      ? [
          {
            id: 'construction-received',
            label: '施工記録',
            anchor: 'registration-received-section',
            icon: <CreateIcon />,
          },
          {
            id: 'documents',
            label: '書類管理',
            anchor: 'received-materials-list-section',
            icon: <FolderIcon />,
          },
        ]
      : []),
  ];

  return <NavigationPanelCommon sections={sections} />;
};
